import { AgGridReact } from 'ag-grid-react';
import { Theme, themeQuartz } from "ag-grid-community";
import React, { useEffect, useState, useMemo } from 'react';
import Loader from '../../../../components/loader';
import { StatusStaticCell, titleCell } from '../../../../components/elements/function';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { useWorkOrderApi } from '../../../../store/api/hooks/workOrderApiHook';
import toast from 'react-hot-toast';
import { showLocalDateTime } from '../../../../_common/functions';
import { useAssetsApi } from '../../../../store/api/hooks/assetsApiHook';

const AssetStatusLog: React.FC = () => {
    const myTheme = themeQuartz.withParams({
        headerBackgroundColor: `#F0F0F0`
    });
    const theme = useMemo<Theme | "legacy">(() => {
        return myTheme;
    }, []);
    const params: any = useParams();
    const [rowData, setrowData] = useState<any[] | null>([]);
    const assetsAPI = useAssetsApi();

    const columnDefs = [
        {
            headerName: 'Status Changed',
            field: 'statusName',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 150,
            cellRenderer: (params: any) => <p className="truncate">{StatusStaticCell(params)}</p>,
        },
        {
            headerName: 'Reason',
            field: 'statusChangeReason',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 150,
            cellRenderer: (params: any) => <p className="truncate">{titleCell(params)}</p>,
        },
        {
            headerName: 'Changed by',
            field: 'performedByName',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 120,
            cellRenderer: (params: any) => <p className="truncate">{titleCell(params)}</p>,
        },
        {
            headerName: 'Changed Date Time',
            field: 'performedDate',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 140,
            cellRenderer: (data: any) => (
                <p className="hover:text-primary font-medium cursor-pointer truncate" title={data.value ? showLocalDateTime(data.value) : '--'}>
                    {data.value ? showLocalDateTime(data.value) : '--'}
                </p>
            ),
        },
        {
            headerName: 'Total Duration',
            field: 'duration',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 120,
            cellRenderer: (params: any) => {
                const totalSeconds = params.value || 0;
                const duration = moment.duration(totalSeconds, 'seconds');
                const hours = Math.floor(duration.asHours());
                const minutes = duration.minutes();
                const seconds = duration.seconds();
                const durationText = `${hours} hr ${minutes} min ${seconds} sec`;
                return (
                    <p className="truncate" title={durationText}>{durationText}</p>
                );
            },
        },
    ];

    const GetAssetStatusLog = (assetID: any = params.id) => {
        const payload: any = {
            AssetID: assetID,
        };
        setrowData(null);
        assetsAPI.GetAssetStatusLog(
            payload,
            (resp: any) => {
                setrowData(resp.assetLogList ? resp.assetLogList : []);
            },
            (error: any) => {
                console.log('error =>', error);
                toast.error(error);
            }
        );
    };

    useEffect(() => {
        if (params.id) {
            GetAssetStatusLog(params.id);
        }
    }, [params]);

    return (
        <div>
            <div className="flex items-center justify-between h-[60px]">
                <h4 className="font-semibold text-[0.938rem]">Asset Status Log</h4>
            </div>
            <div className={`mb-3 ag-theme-alpine overflow-auto ${!rowData || rowData.length === 0 || rowData.length <= 2 ? 'h-[150px]' : 'h-[300px]'}`}>
                <AgGridReact
                    theme={theme}
                    columnDefs={columnDefs}
                    rowData={rowData || []}
                    pagination={false}
                    domLayout="normal"
                    ensureDomOrder={true}
                    suppressHorizontalScroll={false}
                    loadingOverlayComponent={Loader}
                    noRowsOverlayComponent={() => (
                        <div className="flex items-center justify-center h-full">
                            <div className="text-center text-gray-500">
                                <div className="text-lg font-medium">No Data Found</div>
                            </div>
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default AssetStatusLog;